// extracted by mini-css-extract-plugin
export var Contacts = "contacts-module--Contacts--2bwfN";
export var Contacts__item = "contacts-module--Contacts__item--DfZFF";